<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать промокод</strong>
                </CCardHeader>
                <CCardBody>
                    <PromocodeUpsertForm
                        :customer-id="+this.$route.params.id"
                        @success="$router.push(`/promocodes`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import PromocodeUpsertForm from '@/components/promocodes/PromocodeUpsertForm';

    export default {
        name: 'PromocodeCreate',

        components: {
            PromocodeUpsertForm
        },
    };
</script>
